import React from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/free-solid-svg-icons'

import logo from '../img/white-small.png'

// Navbar unificata per la pagina /order (4 stati: confermato, chiuso,
// producer, single/guest). Sostituisce 4 blocchi inline duplicati.
//
// Il logout è stato rimosso dalla navbar: ora vive dentro /settings con
// conferma seria. Per gli utenti autenticati la navbar mostra solo l'icona
// Impostazioni (⚙) come Link a /settings; il guest (no user) vede solo il logo.
function ConsumerNavbar({ user }) {
  return (
    <div className="nav-order">
      <div className="nav-order-title">
        <img src={logo} className="logo-sidebar" alt="CUT Catering" />
      </div>
      {user ? (
        <div className="nav-order-user">
          <Link
            to="/settings"
            className="nav-order-settings"
            title="Impostazioni"
            aria-label="Apri impostazioni"
          >
            <FontAwesomeIcon icon={faGear} />
          </Link>
          <span className="nav-order-name">{user.name}</span>
        </div>
      ) : null}
    </div>
  )
}

export default ConsumerNavbar
